import { CalendarPlus, Clock, Receipt, X } from 'lucide-react';
import { useEffect } from 'react';

const actions = [
  { key: 'appointment', icon: CalendarPlus, label: 'New Appointment', desc: 'Book a service for a client', color: '#556B2F' },
  { key: 'blocked', icon: Clock, label: 'Block Time', desc: 'Block off time in your calendar', color: '#5C6656' },
  { key: 'sale', icon: Receipt, label: 'Quick Sale', desc: 'Record a sale without appointment', color: '#8B9A6B' },
];

export default function MobileAddSheet({ open, onClose, onSelect }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[10001]" data-testid="mobile-add-sheet">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm animate-fadeIn"
        onClick={onClose}
      />

      {/* Sheet */}
      <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl animate-slideUp safe-area-bottom" style={{ paddingBottom: 'env(safe-area-inset-bottom, 8px)' }}>
        {/* Handle bar */}
        <div className="flex justify-center pt-3 pb-1">
          <div className="w-10 h-1 rounded-full bg-[#D1D5CB]" />
        </div>

        <div className="px-5 pb-2">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-[#1A2421]">Create</h2>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-full bg-[#F0F2EC] flex items-center justify-center"
              data-testid="close-add-sheet"
            >
              <X size={16} className="text-[#5C6656]" />
            </button>
          </div>

          <div className="space-y-1 pb-4">
            {actions.map((action) => {
              const Icon = action.icon;
              return (
                <button
                  key={action.key}
                  onClick={() => onSelect(action.key)}
                  className="w-full flex items-center gap-4 p-3.5 rounded-2xl hover:bg-[#F5F7F0] active:bg-[#E9EDDF] transition-colors"
                  data-testid={`add-action-${action.key}`}
                >
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: action.color + '15' }}>
                    <Icon size={22} style={{ color: action.color }} strokeWidth={1.5} />
                  </div>
                  <div className="text-left">
                    <p className="text-[15px] font-semibold text-[#1A2421]">{action.label}</p>
                    <p className="text-xs text-[#5C6656] mt-0.5">{action.desc}</p>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
